import React from 'react';
import FsGridContainer from 'ui-elements/grid/FsGridContainer';
import FsGridItem from 'ui-elements/grid/FsGridItem';
import { WrapperBox } from './InviteCustomer.style-elements';
import InviteDescriptionBox from './InviteDescriptionBox';
import InviteForms from './InviteForms';

const InviteCustomer: React.FC = () => {
  return (
    <WrapperBox>
      <FsGridContainer>
        <FsGridItem xs={12}>
          <InviteDescriptionBox />
        </FsGridItem>
        <FsGridItem xs={12}>
          <InviteForms />
        </FsGridItem>
      </FsGridContainer>
    </WrapperBox>
  );
};

export default InviteCustomer;
